import { type FC } from 'react';

import { ArrowRight } from 'lucide-react';
import { Link } from 'react-router-dom';

import { tokens } from '@shared/styles/tokens';
import type { IEquipmentItem } from '@shared/types';
import { Picture } from '@shared/ui/Picture';

import styles from './CatalogList.module.css';

interface CatalogListProps {
  items: readonly IEquipmentItem[];
  basePath: string;
}

export const CatalogList: FC<CatalogListProps> = ({ items, basePath }) => (
  <ul className={styles.list} role="list">
    {items.map((item) => (
      <li key={item.id}>
        <Link className={styles.row} to={`${basePath}/${item.id}`}>
          <span className={styles.number}>{item.number}</span>
          <span className={styles.thumb}>
            {item.photos[0] && (
              <Picture
                className={styles.image}
                src={item.photos[0]}
                sizes={tokens.layout.catalogThumb}
                alt=""
              />
            )}
          </span>
          <span className={styles.info}>
            <span className={styles.title}>{item.title}</span>
            <span className={styles.description}>{item.description}</span>
          </span>
          <span className={styles.arrow} aria-hidden="true">
            <ArrowRight />
          </span>
        </Link>
      </li>
    ))}
  </ul>
);
